// extracted by mini-css-extract-plugin
export default {"video":"barcodeScanner_video__56b1k","rectangle":"barcodeScanner_rectangle__fJVfg","close":"barcodeScanner_close__s41CY"};